export default __webpack_public_path__ + "static/media/yacht3.4a416246.webp";